import { api } from "../../../../api";
import {
  CargoPackagingProps,
  CargoPackagingResponse,
  RequestPackingParams,
} from "./types";

export async function getPackingApi(
  id: number,
  params: RequestPackingParams,
): Promise<CargoPackagingResponse> {
  const { data } = await api.get<CargoPackagingResponse>(
    `/api/shipping-cases/${id}/packing-lists`,
    { params },
  );
  return data;
}

export async function updatePackingApi(
  id: number,
  params: Partial<CargoPackagingProps>,
): Promise<Partial<CargoPackagingProps>> {
  const { data } = await api.patch<Partial<CargoPackagingProps>>(
    `/api/packing-lists/${id}`,
    {
      ...params,
    },
  );
  return data;
}

export async function exportPackingListApi(
  id: number,
  params?: Partial<RequestPackingParams>,
): Promise<{
  file: Blob;
  filename: string;
}> {
  const response = await api.get(
    `/api/shipping-cases/${id}/packing-lists/export`,
    {
      params,
      responseType: "blob",
    },
  );
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}

export async function loadFileApi(data: File, id: number): Promise<void> {
  const form = new FormData();
  form.append("file", data);

  await api.post(`/api/shipping-cases/${id}/packing-lists/import`, form, {
    headers: {
      "Content-Type": undefined,
    },
  });
}
